import { t } from "i18next";
import { useState } from "react";
import Draggable from "react-draggable";
import {
  Button,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import swal from "sweetalert";
import { applyClassToCharacters, isUrdu, LoadingSpinner } from "../../../constants/const";
import { GetLanguageString } from "../../helper/Components";
import { GetSelectedLanguage } from "../../helper/Method";
import ApiFinanceConfig from "./ApiFinanceConfig";

import { STANDARD_FINANCE_KEYS } from "./FinanceConfig";

const EditFinanceConfig = ({
  selectedProgress,
  setEditModal,
  refresh,
  setRefresh,
}) => {
  const [formData, setFormData] = useState(selectedProgress);
  const [errors, setErrors] = useState();
  const [loading, setLoading] = useState(false);
  const [buttonDisable, setButtonDisable] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });

  const stdMeta = STANDARD_FINANCE_KEYS.find(
    (k) => k.value.toLowerCase() === formData.key?.toLowerCase()
  );
  const isUr = GetSelectedLanguage() === "ur";
  const displayLabel = stdMeta
    ? isUr
      ? `${stdMeta.urduLabel} (${stdMeta.label})`
      : `${stdMeta.label} (${stdMeta.urduLabel})`
    : formData.key;

  const handleDrag = (e, ui) => {
    const { x, y } = position;
    setPosition({ x: x + ui.deltaX, y: y + ui.deltaY });
  };

  const validate = () => {
    let temp = {};
    temp.key = formData.key?.trim() ? (
      ""
    ) : (
      <GetLanguageString props="common_field_required_error" />
    );
    temp.value = formData.value?.trim() ? (
      ""
    ) : (
      <GetLanguageString props="common_field_required_error" />
    );

    setErrors({
      ...temp,
    });
    return Object.values(temp).every((x) => x === "");
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    setErrors({
      ...errors,
      [name]: "",
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      setLoading(true);
      setButtonDisable(true);
      ApiFinanceConfig()
        .Update(formData.id, {
          ...formData,
          key: formData.key?.trim(),
          value: formData.value?.trim(),
        })
        .then((res) => {
          swal({
            title: t("finance_config_edited"),
            className: GetSelectedLanguage() === "en" ? "" : "ur",
            icon: "success",
            buttons: GetSelectedLanguage() === "en" ? "OK" : "ٹھیک ہے ",
          });

          setRefresh(!refresh);
          setEditModal(false);
          setLoading(false);
          setButtonDisable(false);
        })
        .catch((err) => {
          const errorMsg =
            err.response?.data?.message ||
            err.response?.data ||
            t("common_something_went_wrong");
          swal({
            title: errorMsg,
            icon: "error",
            buttons: "OK",
          });
          setLoading(false);
          setButtonDisable(false);
        });
    }
  };

  return (
    <Draggable position={position} onDrag={handleDrag} cancel=".no-drag">
      <Modal isOpen={true} className="inmodal" autoFocus={false}>
        <ModalHeader className="modal-title" tag="h4">
          <GetLanguageString props="finance_config_edit" />
        </ModalHeader>
        {!loading ? (
          <Form onSubmit={handleSubmit}>
            <ModalBody>
              <FormGroup>
                <Label>
                  <GetLanguageString props="finance_config_key" />
                </Label>
                <div
                  style={{
                    backgroundColor: "#f9fbfb",
                    border: "1px solid #e7eaec",
                    borderRadius: "4px",
                    padding: "10px 14px",
                  }}
                >
                  <div style={{ fontWeight: 600, fontSize: "14px", color: "#2f4050" }}>
                    {isUr ? (
                      applyClassToCharacters(stdMeta?.urduLabel || stdMeta?.label || formData.key, "ur")
                    ) : (
                      <span>{stdMeta?.label || formData.key}</span>
                    )}
                  </div>
                  {(stdMeta?.urduDescription || stdMeta?.description) && (
                    <small className="text-muted mt-1 d-block" style={{ fontSize: "12px", lineHeight: "1.4" }}>
                      {applyClassToCharacters(
                        isUr ? (stdMeta.urduDescription || stdMeta.description) : stdMeta.description,
                        "ur"
                      )}
                    </small>
                  )}
                  <div style={{ fontSize: "11px", color: "#888", marginTop: "4px" }}>
                    <code style={{ fontSize: "11px", color: "#1a6b5c", backgroundColor: "#eef8f6", padding: "1px 5px", borderRadius: "3px" }}>
                      {formData.key}
                    </code>
                  </div>
                </div>
              </FormGroup>
              <FormGroup>
                <Label>
                  <GetLanguageString props="finance_config_value" />
                </Label>
                <Input
                  autoFocus
                  type="text"
                  name="value"
                  className={
                    isUrdu(formData.value) ? "no-drag ur" : "no-drag"
                  }
                  value={formData.value}
                  onChange={handleInputChange}
                  {...(errors?.value && { invalid: true })}
                />
                {errors?.value && (
                  <FormFeedback>
                    <h4>{errors?.value}</h4>
                  </FormFeedback>
                )}
              </FormGroup>
            </ModalBody>
            <ModalFooter>
              <Button color="white" onClick={() => setEditModal(false)}>
                <GetLanguageString props="common_cancel" />
              </Button>
              <Button color="primary" type="submit" disabled={buttonDisable}>
                <GetLanguageString props="common_save" />
              </Button>
            </ModalFooter>
          </Form>
        ) : (
          LoadingSpinner()
        )}
      </Modal>
    </Draggable>
  );
};

export default EditFinanceConfig;
